// src/locales/si/orderAssignment.js
export const orderAssignment = {
  specialNote: 'විශේෂ සටහන',
  // Page titles
  configurationTitle: 'Order පවරීම් නියමයන්',
  configurationSubtitle: 'Order auto-assign rules configure කරන්න',
  manualAssignmentTitle: 'Manual Order Assignment',
  manualAssignmentSubtitle: 'Bulk order assign කිරීම',
  myWorkQueue: 'මගේ Work Queue',
  workQueueSubtitle: 'ඔබට පවරා ඇති Orders කළමනාකරණය කරන්න',

  // Shop selection
  shopSelection: 'Shop තේරීම',
  selectShop: 'Shop තෝරන්න',
  selectShopPlaceholder: 'Shop තෝරන්න',
  shopWithOrderCount: '{{name}} ({{type}}) - {{count}} orders',

  // Auto-assignment status
  autoAssignmentStatus: 'Auto-Assignment තත්වය',
  autoAssignmentEnabled: 'Auto-Assignment සක්‍රීයයි',
  autoAssignmentDisabled: 'Auto-Assignment අක්‍රීයයි',
  enabledDescription: 'නව Orders rules අනුව auto-assign වේ',
  disabledDescription: 'Auto-assign කිරීමට enable කරන්න',

  // Grand total rules
  grandTotalRules: 'Grand Total Rules',
  grandTotalRulesInfo: 'Grand Total අනුව Orders පරිශීලකයන්ට assign කරන්න. Rule order අනුව process වේ.',
  addRule: 'Rule එකක් එක් කරන්න',
  deleteRule: 'Rule Delete',
  ruleNumber: 'Rule #{{number}}',
  minimumAmount: 'අවම මුදල',
  maximumAmount: 'උපරිම මුදල',
  noMinimum: 'අවම නොමැත',
  noMaximum: 'උපරිම නොමැත',
  assignTo: 'Assign කරන්න',
  selectUsers: 'පරිශීලකයන් තෝරන්න...',
  searchUsers: 'පරිශීලකයන් සොයන්න...',
  rangePreview: 'Range: {{min}} - {{max}}',
  rangePreviewCurrency: 'Range: {{min}} - {{max}}',
  rangePreviewInfinity: 'Range: {{min}} - ∞',
  rangePreviewZeroToInfinity: 'Range: 0 - ∞',
  noGrandTotalRules: 'Grand Total Rules configure කර නැත',
  addFirstRule: 'පළමු Rule එකක් එක් කරන්න',
  to: 'to',

  // Product rules
  productRules: 'Product Rules',
  productRulesInfo: 'නියමිත Products තිබේ නම් Order assign කරන්න',
  products: 'Products',
  selectProducts: 'Products තෝරන්න...',
  searchProducts: 'Products සොයන්න...',
  noProductRules: 'Product Rules configure කර නැත',
  allProducts: 'සියලු Products',

  // Default assignment
  defaultAssignment: 'Default Assignment',
  defaultAssignmentInfo: 'Rule වලට නොගැලපෙන Orders Default Users වෙත assign වේ.',
  defaultAssignees: 'Default Assign කරන අය',
  selectDefaultUsers: 'Default Users තෝරන්න...',
  defaultAssignmentNote: 'Rules match නොවුන Orders මෙයට assign වේ',

  // Manual assignment
  assignmentConfiguration: 'Assignment සැකසුම්',
  orderSelection: 'Orders තේරීම (Optional)',
  ordersEligible: '{{count}} orders eligible',
  clearSelection: 'තේරීම මකන්න',
  selectAllOrders: 'සියලු Orders තෝරන්න',
  assignmentPreview: 'Preview',
  ordersToAssign: 'Assign කිරීමට Orders',
  usersAssigned: 'Assign කරන පරිශීලකයන්',
  unassignedOrders: 'Assign නොවූ Orders',
  unbalancedWarning: 'Unbalanced',
  showPreview: 'Preview පෙන්වන්න',
  hidePreview: 'සඟවන්න',
  executeAssignment: 'Assign කරන්න',
  executing: 'Assign කරමින්...',
  executeAssignmentWithCount: 'Assign ({{count}} orders)',
  moreOrders: '+{{count}} Orders',
  unassigned: 'Assign නොවූ',
  ordersCount: '{{count}} orders',

  // Work Queue
  totalAssigned: 'පවරා ඇති Orders',
  confirmedVerified: 'තහවුරු කළ (ගෙවීම් සත්‍යාපිත)',
  confirmedNotVerified: 'තහවුරු කළ (ගෙවීම් සත්‍යාපිත නොවේ)',
  orderValue: 'Order Value',
  statusBreakdown: 'Status Breakdown',
  assignmentStats: 'Assignment Stats',
  assignedOrders: 'Assign කළ Orders',
  assignmentDistribution: 'Assignment Distribution',
  loadingWorkQueue: 'Orders load වෙමින්...',
  unableToLoadWorkQueue: 'Load cannot',
  noOrdersAssigned: 'Orders assign කර නැත',
  noOrdersAssignedDescription: 'ඔබට Orders assign කර නොමැත',
  noOrdersFound: 'Orders සොයාගත cannot',
  noOrdersFoundDescription: 'Search filters වලට ගැලපෙන Orders නැත',
  ordersSelected: '{{count}} orders selected',
  searchPlaceholder: 'Order / Customer නමින් සොයන්න…',

  // Table columns
  order: 'Order',
  orderNumber: 'Order Number',
  paymentMethods: 'Payment Methods',
  payments: 'ගෙවීම්',
  customer: 'Customer',
  customerName: 'Customer Name',
  status: 'Status',
  total: 'Total',
  assigned: 'Assigned',
  orderStatus: 'Order Status',
  statusReason: 'Reason',
  allStatuses: 'All Statuses',
  allReasons: 'All Reasons',
  minGrandTotal: 'අවම Grand Total',
  maxGrandTotal: 'උපරිම Grand Total',

  // Order details
  orderDetails: 'Order Details',
  orderInformation: 'Order තොරතුරු',
  orderDate: 'Order Date',
  grandTotal: 'Grand Total',
  currentStatus: 'Current Status',
  customerInformation: 'Customer තොරතුරු',
  name: 'නම',
  phone: 'දුරකථන',
  email: 'Email',
  address: 'ලිපිනය',
  orderItems: 'Order Items',
  sku: 'SKU',

  // Status update
  updateStatus: 'Status Update',
  updateOrderStatus: 'Order Status Update',
  newStatus: 'New Status',
  selectStatus: 'Status තෝරන්න...',
  selectReason: 'Reason තෝරන්න...',
  holdUntilDate: 'Hold Date',
  holdUntil: 'Hold until',
  updateStatusButton: 'Status Update',
  updating: 'Update වෙමින්...',
  confirmStatusChange: 'මෙම Order එක "{{status}}" ලෙස සලකුණු කිරීමට විශ්වාසද?',

  // Bulk operations
  bulkUpdateStatus: 'Bulk Status Update',
  aboutToUpdateOrders: 'Orders {{count}} update කිරීමට සූදානම්',
  bulkUpdateDescription: 'තෝරාගත් Orders එකම Status එකට update වේ',
  updateOrdersCount: '{{count}} Orders Update',

  // Assignment results
  assignmentComplete: 'Assign කිරීම සම්පූර්ණය',
  successfullyAssigned: '{{count}} Orders assign විය',
  assignmentFailed: 'Assign කිරීම අසාර්ථකයි',

  // Metadata
  lastUpdated: 'අවසාන Update: {{date}}',
  updatedBy: 'Update කළේ: {{name}}',
  updatedByUser: 'Update කළේ: {{name}}',
  updatedByUnknown: 'Update කළේ: Unknown',
  assignedAt: 'Assign කළ தேதி',

  // Actions
  backToOrders: 'Orders වෙත',
  saveRules: 'Rules Save කරන්න',
  cancel: 'Cancel',
  saving: 'Saving...',

  // Validation errors
  atLeastOneUser: 'අවම වශයෙන් User 1ක් තෝරන්න',
  maxMustBeGreaterThanMin: 'Maximum ≥ Minimum විය යුතුය',
  atLeastOneProduct: 'අවම වශයෙන් Product 1ක් තෝරන්න',
  atLeastOneRuleOrDefault: 'Auto-Assign සක්‍රීය時 Rule හෝ Default Users එකක් අවශ්‍යයි',
  noOrdersAvailable: 'Assign සඳහා Orders නැත',
  noOrdersCanBeAssigned: 'Rules වලට ගැලපෙන Orders නැත',
  shopRequired: 'Shop තෝරන්න',
  selectAtLeastOneOrder: 'Order 1ක්වත් තෝරන්න',
  pleaseSelectStatus: 'Status තෝරන්න',
  pleaseSelectReason: 'Reason තෝරන්න',
  pleaseSelectHoldDate: 'Hold Date තෝරන්න',

  // Success/Error messages
  rulesSavedSuccess: 'Rules Save විය',
  rulesSaveFailed: 'Rules Save cannot',
  loadingConfig: 'Config Load වෙමින්...',
  loadingConfigMessage: 'Rules Load වෙමින්',
  loadingAssignmentData: 'Assignment Data Load වෙමින්...',
  loadingAssignmentMessage: 'දත්ත Load වෙමින්...',
  loadDataFailed: 'Data load cannot. Page refresh කරන්න.',
  loadOrdersFailed: 'Orders load cannot',
  unsavedChanges: 'Unsaved changes ඇත. Discard කරන්නද?',
  fixValidationErrors: 'වැරදි සකසන්න',
  fixValidationBeforeExecuting: 'Assign කිරීමට පෙර වැරදි සකසන්න',
  confirmAssignment: '{{count}} Orders assign කරන්නද?',
  confirmAssignmentWithUnassigned: '{{assigned}} Orders assign කරයි.\n\n{{unassigned}} Orders assign නොවේ.',
  confirmAssignmentUnbalanced: '{{assigned}} Orders assign කරයි.\n\n{{unassigned}} Orders assign නොවේ.\n\nUnbalanced Assignment!',
  unassignedWarning: '{{count}} Orders assign නොවේ.',
  unbalancedAssignmentWarning: 'Assignment Unbalanced',
  noChanges: 'වෙනස්කම් නැත',
  orderStatusUpdated: 'Order Status update විය',
  failedToUpdateStatus: 'Status update cannot',
  bulkUpdateSuccess: '{{count}} Orders update විය',
  failedToUpdateSomeOrders: 'บาง Orders update cannot',
  failedToUpdateOrders: 'Orders update cannot',
  assignedUser: "පවරන ලද පරිශීලකයා",
  notAssigned: "පවරා නැත",
  assignedTo: "පවරා ඇත්තේ",
};
